import { FC } from 'react';
import { Button, Modal } from 'antd';

import close from '../../assets/RoundedClose.svg';
import Questionnaire from '../../assets/Define Phase Questionnaire.svg';

interface ModalProps {
    openModal: boolean;
    setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
    handleStartQuestionary: () => void;
    formData: any;
    /** Intro opened from Define vs Design questionnaire task — affects primary CTA label. */
    variant?: 'define' | 'design';
}

export const AboutQuestionaryModal: FC<ModalProps> = ({
    openModal,
    setOpenModal,
    handleStartQuestionary,
    formData,
    variant = 'define'
}) => {
    const primaryCtaLabel = variant === 'design' ? 'View scope' : 'Start Questionnaire';
    return (
        <>
            <Modal
                className="modal-modal"
                destroyOnClose
                centered
                open={openModal}
                onOk={() => {}}
                onCancel={() => {
                    setOpenModal(false);
                }}
                closeIcon={<img src={close} />}
                footer={
                    <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                        <Button block key="submit" type="primary" onClick={handleStartQuestionary}>
                            {primaryCtaLabel}
                        </Button>
                    </div>
                }
            >
                <div className="modal">
                    <div className="modal__header meeting" style={{ height: '88px' }}>
                        <div className="modal__title">Kick-off Questionnaire</div>
                    </div>

                    <div className="modal__main main" style={{ padding: '24px 56px 43px 56px' }}>
                        <img src={Questionnaire} />
                        <div className="main__title-no-head">About this Questionnaire</div>
                        <p className="main__subtitle">{formData?.description}</p>
                    </div>
                </div>
            </Modal>
        </>
    );
};
